// extracted by mini-css-extract-plugin
module.exports = {"itemsFilter":"ItemsFilter-module__itemsFilter___1J8B3"};